module.exports = __webpack_public_path__ + "img/partnership_logo_qualifi.1e74154d.jpg";